export default "__VITE_ASSET__CUP1XPrn__"